import { IoMdRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io"

export default function CoursePricingApplication({ setApplicationState, applicationPiece }) {
  return (
    <>
      <h5>Course Pricing</h5>
      <p>Add a price point for this course</p>
      <div className="intended-learners-wr">
      <input onChange={(e)=>{setApplicationState(prev=>({...prev, coursePlan: {...prev.coursePlan, courseFee: {...prev.coursePlan.courseFee, amount: e.target.value}}}))}} value={applicationPiece.courseFee.amount} placeholder="Example: 80, 125, 100" type="number" />
      </div>
      <h5>Currency (Optional, defaults to USD)</h5>
      <p>Choose a specific currency for the pricing</p>
      <div className="intended-learners-wr">
        <input onChange={(e)=>{setApplicationState(prev=>({...prev, coursePlan: {...prev.coursePlan, courseFee: {...prev.coursePlan.courseFee, currency: e.target.value}}}))}} value={applicationPiece.courseFee.currency}  placeholder="Example: USD, GBP" type="text" />
      </div>
    </>
  )
}